import React from "react";
import { useHistory } from "react-router-dom";
import "../../assets/scss/components/_relatedservices.scss";

const RelatedServices = ({ services = [] }) => {
  const history = useHistory();

  return (
    <section className="related">
      <div className="related__container">
        <h3>Related Services</h3>

        <div className="related__grid">
          {services.map((item, index) => (
            <div
              className="related__card"
              key={index}
              onClick={() => history.push(`/packages/${item.slug}`)}
            >
              <div className="related__image">
                <img
                  src={require(`../../assets/img${item.image}`)}
                  alt={item.title}
                />{" "}
              </div>

              <h4>{item.title}</h4>

              <button>Read More</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedServices;
